import {environment} from '../../../environments/environment';
import {PolarisEnvId} from './model';

export {PolarisEnvId};

/** Minimal shape used by Polaris for env detection (avoids loose cast on environment). */
interface EnvironmentWithEnv {
  env?: string;
}

const ENV_INPUT_TO_ID: Record<string, PolarisEnvId> = {
  production: PolarisEnvId.PRODUCTION,
  prod: PolarisEnvId.PRODUCTION,
  qa: PolarisEnvId.QA,
  local: PolarisEnvId.LOCAL
};

export function getPolarisEnvId(): PolarisEnvId {
  const env = (environment as EnvironmentWithEnv).env ?? '';
  const normalized = env.toLowerCase();
  return ENV_INPUT_TO_ID[normalized] ?? PolarisEnvId.LOCAL;
}
